import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { SharedModule }                       from '../shared/shared.module';
import { TableModule }                        from '../table/table.module';
import { TransactionCenterInspectionsModule } from './inspections/transaction-center.inspections.module';
import { TransactionCenterJobsModule }        from './jobs/transaction-center.jobs.module';
import { TransactionCenterStates }            from './transaction-center.states';

import { TransactionCenterComponent }               from './transaction-center.component';
import { TransactionCenterBookingsComponent }       from './transaction-center.bookings.component';
import { TransactionCenterOrdersComponent }         from './transaction-center.orders.component';
import { TransactionCenterVendorInvoicesComponent } from './transaction-center.vendor-invoices.component';

@NgModule({
  declarations: [
    TransactionCenterComponent,
    TransactionCenterBookingsComponent,
    TransactionCenterOrdersComponent,
    TransactionCenterVendorInvoicesComponent
  ],
  entryComponents: [
    TransactionCenterComponent,
    TransactionCenterBookingsComponent,
    TransactionCenterOrdersComponent,
    TransactionCenterVendorInvoicesComponent
  ],
  imports: [
    SharedModule,
    TableModule,
    TransactionCenterInspectionsModule,
    TransactionCenterJobsModule,
    UIRouterModule.forChild({ states: TransactionCenterStates })
  ]
})
export class TransactionCenterModule {}
